import type { CSSObject } from '@deity/falcon-ui';
import { createTheme } from '@deity/falcon-ui';
import { badge } from './falconComponents/badge';
import { button } from './falconComponents/button';
import { input } from './falconComponents/input';
import { icons } from './icons';

export const themeVariables = {
  colors: {
    primary: '#5660e1',
    primaryLight: '#ebedff',
    primaryDark: '#1E183C',
    primaryText: '#1C1F23',
    secondary: '#919AA7',
    secondaryLight: '#F3F5F7',
    secondaryDark: '#555D66',
    secondaryText: '#A3A0B0',
    error: '#EB5757',
    errorText: '#EB5757',
    errorTextDark: '#AE424D',
    errorLight: '#FDEDEC',
    errorDark: '#F7C0C0',
    successLight: '#ECF7EE',
    successDark: '#61A359',
    black: 'black',
    white: 'white',
    transparent: 'transparent',
    focus: 'blue',
    warning: '#f7d677',
    warningDark: '#9A7628',
    warningLight: '#FFFCEB',
    warningTextDark: '#9A7628',
    green: '#569640',
    lightGrey: '#F3F5F7',
    border: '#C1C8D0',
    borderLight: '#E0E2E5',
    labelText: '#8A8799',
    badgeBg: '#383E45',
    badgeText: '#737B87',
    panelLight: '#f8f8f8'
  },

  spacing: {
    auto: 'auto',
    full: '',
    none: 0,
    xxs: 4,
    xs: 8,
    xss: 12,
    sm: 16,
    md: 28,
    lg: 32,
    xl: 40,
    xxl: 48,
    xxxl: 64
  },

  fonts: {
    sans: 'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
    mono: 'Courier New, monospace'
  },

  fontSizes: {
    xxs: 11,
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    llg: 21,
    xl: 24,
    xll: 28,
    xxl: 40,
    xxxl: 48
  },

  fontWeights: {
    normal: 'normal',
    light: 400,
    semiBold: 500,
    regular: 300,
    bold: 600
  },

  letterSpacings: {
    normal: '0',
    caps: '0.08em'
  },

  lineHeights: {
    small: 1,
    default: 1.3,
    large: 1.6
  },

  borders: {
    none: 'none',
    regular: '1px solid',
    semiBold: '2px solid',
    bold: '4px solid'
  },

  borderRadius: {
    none: 0,
    round: 9999,
    small: 8,
    large: 32,
    medium: 16
  },

  boxShadows: {
    none: 'none',
    subtle: '0px 10px 30px rgba(30, 24, 60, 0.1)',
    strong: '0px 12px 16px rgba(0, 0, 0, 0.15)',
    distant: '0px 8px 24px rgba(0, 0, 0, 0.12)',
    pronounced: '0px 10px 30px rgba(30, 24, 60, 0.1)'
  },

  transitionDurations: {
    short: '100ms',
    standard: '200ms',
    long: '1s'
  },

  breakpoints: {
    xs: 0,
    sm: 640,
    md: 960,
    lg: 1280,
    xl: 1920
  },

  keyframes: {
    slideLeft: {
      from: {
        transform: 'scaleX(1)',
        transformOrigin: 'right center'
      },
      to: {
        transform: 'scaleX(0)',
        transformOrigin: 'right center'
      }
    },
    slideRight: {
      from: {
        transform: 'scaleX(0)',
        transformOrigin: 'left center'
      },
      to: {
        transform: 'scaleX(1)',
        transformOrigin: 'left center'
      }
    }
  },
  components: {
    button,
    badge,
    input
  },
  icons
};

/**
 * Create theme with default variables
 */
export const dataIntegratorTheme = createTheme(themeVariables);

/**
 * Create global styles
 */
export const globalCss: CSSObject = {
  body: {
    margin: 0,
    // overflowX: 'hidden',
    backgroundColor: '#f5f5f5'
  },
  html: {
    fontFamily:
      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
    overflowX: 'hidden',
    overflowY: 'scroll'
  }
};

// primaryLight: '#D5D3F0',
// primary: '#5A4ECC',
// primaryDark: '#4A3D75',
// primaryDarker: '#1E183C',
// primaryText: '#2A2C3A',
// primaryTextLight: '#8A8799',
// labelText: '#8A8799',
// bodyBG: '#F6F6F6',
// border: '#E0E2E5',
// deityGreen: '#A0CC3F',

// secondaryLighter: '#FAF9F8',
// secondaryLight: '#F2F0F0',
// secondary: '#569640',
// secondaryDark: '#E0E2E5',
// secondaryDarker: '#BFBFBB',
// secondaryText: '#50515E',
// secondaryTextLight: '#B3B7B3',

// accentLight: '#61C02A',
// accent: '#338537',
// accentDark: '#07532E',

// light: '#FFFFFF',
// dark: `#000000`,
// error: '#EB5757',
// warning: '#F2994A',
// success: '#4AAE4E',
// info: '#176FF2'
